import { render, staticRenderFns } from "./reportPayFeeDetailList.vue?vue&type=template&id=483b46df&scoped=true"
import script from "./reportPayFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportPayFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportPayFeeDetailList.vue?vue&type=style&index=0&id=483b46df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b46df",
  null
  
)

export default component.exports